// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vf6z","colMin":"styles_colMin__yLdoS"};